import DownloadFilesApi from '@/services/api/DownloadFiles';
import { __LINKS, OrgRoles } from '@/const';
import Config from '@/rearchitected/core/js/ddriven/application/config/Config';
import store from '@/store';

export default {
    methods: {
        $scrollToHash() {
            // @ts-ignore
            this.$nextTick(() => {
                let el;
                // @ts-ignore
                if (this.$route.hash && (el = document.querySelector(this.$route.hash))) {
                    const y = el.getBoundingClientRect().top + window.pageYOffset - 255;
                    window.scrollTo({ top: y });
                }
            });
        },
        orgRoleIsPermitted(orgRole) {
            if (typeof store.state.organization.roles !== 'undefined') {
                return store.state.organization.roles.includes(orgRole);
            } else {
                return false;
            }
        },
        $formatPrice(value) {
            let val = (value / 1).toFixed(2).replace('.', ',');
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        },
        $formatPriceOrMdash(value) {
            if (value == null) {
                return '—';
            }
            let val = (value / 1).toFixed(2).replace('.', ',');
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        },
        $parsePhone(text) {
            if (text) return text.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1 ($2) $3-$4-$5');
            return '-';
        },
        isObject(item) {
            return item && typeof item === 'object' && !Array.isArray(item) && item !== null;
        },
        $scrollToTop() {
            window.scrollTo(0, 0);
        },
        isDevEnv() {
            return process.env.NODE_ENV !== 'production';
        },
        isPurchaseCreator() {
            return this.$store.getters.isLoggedIn && this.$store.state.user.organization_id === this.purchase.organization_id;
        },
        isCustomer() {
            return this.$store.getters.isLoggedIn;
        },
        isGuest() {
            return !this.$store.getters.isLoggedIn;
        },
        $commonDocumentDownload(file) {
            DownloadFilesApi.documentDownload(file);
        },
        $getAttachmentDownloadLink(id) {
            return `${Config.get('api.config.legacy.url')}/documents/${id}`;
        }
    },
    computed: {
        $links() {
            return __LINKS;
        },
        $orgRoles() {
            return OrgRoles;
        }
    }
};
